<form [formGroup]="form">
  <div class="d-lg-flex align-items-center mb-2">
    <app-client-autocomplete *ngIf="allowClientSelection" [(selectedClient)]="selectedClient" class="client-autocomplete me-2"></app-client-autocomplete>
    <ng-container *ngIf="selectedClient || !allowClientSelection">
      <div class="d-flex align-items-center">
        <label class="control-label required me-2">{{'i18n.domain.reports.filter.fields.month' | translate}}:</label>
        <ejs-datepicker #monthPicker
                        formControlName="month"
                        format="MMM yyyy"
                        class="me-2"
                        id="startDate"
                        [start]="calendarStart"
                        [depth]="calendarDepth">
        </ejs-datepicker>
      </div>
      <div class="d-flex align-items-center" *ngIf="!authService.isUserStandardUser() else clientParkerSelector">
        <label class="control-label required me-2">{{'i18n.domain.reports.filter.fields.parker' | translate}}:</label>
        <app-autocomplete [getDataFunction]="searchParkerDropdownValues.bind(this)"
                          [fields]="keyValueDropdownSettings"
                          [(value)]="selectedParkerId"
                          [isFormComponent]="true"
                          placeholder="i18n.domain.reports.filter.fields.parker-dropdown-placeholder"
                          id="parkerId">
        </app-autocomplete>
      </div>
      <ng-template #clientParkerSelector>
        <div class="d-flex align-items-center">
          <label class="control-label required me-2">{{'i18n.base.shared.client-dropdown.client' | translate}}:</label>
          <ejs-dropdownlist [dataSource]="clientParkerDropdownValues"
                            [fields]="keyValueDropdownSettings"
                            id="clientParker"
                            [showClearButton]="true"
                            formControlName="parkerId">
          </ejs-dropdownlist>
        </div>
      </ng-template>
    </ng-container>
  </div>
</form>
